import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "./context/CartContext";
import { AuthProvider } from "./context/AuthContext";
import { Layout } from "./components/Layout";
import Home from "./pages/Home";
import Products from "./pages/Products";
import ProductDetail from "./pages/ProductDetail";
import Categories from "./pages/Categories";
import KnowledgeBase from "./pages/KnowledgeBase";
import Article from "./pages/Article";
import Cart from "./pages/Cart";
import About from "./pages/About";
import Account from "./pages/Account";
import AuthCallback from "./pages/AuthCallback";
import Downloads from "./pages/Downloads";
import Reviews from "./pages/Reviews";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";

// Catches ANY route that arrives with `#session_id=...` in the URL
// (that's what Emergent Auth appends after Google sign-in)
function RouterShell() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return (
      <Layout>
        <AuthCallback />
      </Layout>
    );
  }
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/products" element={<Products />} />
        <Route path="/products/:slug" element={<ProductDetail />} />
        <Route path="/categories" element={<Categories />} />
        <Route path="/knowledge" element={<KnowledgeBase />} />
        <Route path="/knowledge/:slug" element={<Article />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/about" element={<About />} />
        <Route path="/account" element={<Account />} />
        <Route path="/downloads" element={<Downloads />} />
        <Route path="/reviews" element={<Reviews />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <CartProvider>
            <RouterShell />
            <Toaster
              theme="dark"
              position="bottom-right"
              toastOptions={{
                style: {
                  background: "#0e0e0e",
                  border: "1px solid #2A2A2A",
                  color: "#ffffff",
                },
              }}
            />
          </CartProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
